if (!customElements.get('hero-slider')) {
  class HeroSlider extends SwiperComponent {
    constructor() {
      super();
      this.lastActiveIndex = null;
    }

    connectedCallback() {
      // Override parent's connectedCallback
      // We'll use SwiperComponent's init method
      this.swiperOptions = this.buildHeroSliderOptions();
      this.swiperInitialized = false;
      this.section = this.closest('section');
      this.observer = null;

      // Initialize swiper (using SwiperComponent's logic)
      if (this.section && this.section.classList.contains('shopify-section')) {
        this.observer = new IntersectionObserver((entries, observer) => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              this.init();
              observer.disconnect();
            }
          });
        });
        this.observer.observe(this.section);
      }

      if (Shopify.designMode) {
        window.addEventListener('shopify:section:load', () => this.init());
        window.addEventListener('shopify:section:select', () => this.init());

        setTimeout(() => {
          if (!this.swiperInitialized) this.init();
        }, 100);
      } else {
        window.addEventListener('load', () => this.init());
      }

      // Hero-specific event listeners
      window.addEventListener('shopify:block:select', e => {
        if (this.swiper && e.target.closest('hero-slider') === this) {
          const selectedSlideIndex = +e.target.dataset.index;
          this.swiper.slideTo(selectedSlideIndex, 600);
        }
      });

      this.addKeyboardNavigation();
    }

    buildHeroSliderOptions() {
      const autoplayOptions = {
        delay: this.dataset.autoplayInterval || 5000
      };

      return {
        rewind: true,
        slidesPerView: 1,
        speed: 600,
        followFinger: false,
        navigation: {
          nextEl: '.swiper-button--next',
          prevEl: '.swiper-button--prev'
        },
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
          renderBullet: function (i, className) {
            return `
              <button class="${className}">
                <span>0${i + 1}</span>
                <svg class="square-progress" width="26" height="26">
                  <rect class="square-origin" width="26" height="26" rx="5" ry="5" />
                </svg>
                <svg class="progress" width="1.8rem" height="1.8rem" style="inset-inline-start: ${0 - (i * 2.4 + 3.4)}rem">
                  <circle class="circle-origin" r="0.8rem" cx="0.95rem" cy="0.95rem"></circle>
                </svg>
              </button>
            `;
          }
        },
        autoplay: this.dataset.autoplay === 'true' ? autoplayOptions : false,
        on: {
          init: this.handleSlideChange.bind(this),
          slideChange: this.handleSlideChange.bind(this)
        }
      };
    }

    init() {
      if (this.swiperInitialized) return;
      this.swiperInitialized = true;

      // Use custom Swiper options for HeroSlider
      this.swiper = new Swiper(this, this.swiperOptions);

      // Maintain slider property for backward compatibility
      this.slider = this.swiper;
    }

    handleSlideChange(swiper) {
      this.handleSlideChangeAnimations(swiper);

      /** change header menu color for active slide */
      let headerInner = document.querySelector('.header__inner');
      let heroInners = document.querySelectorAll('.hero__inner');

      if (!headerInner || !heroInners) {
        return;
      }

      // change --transparent-header-menu-text-color value on document style attributes
      document.documentElement.style.setProperty(
        '--transparent-header-menu-text-color',
        heroInners[swiper.activeIndex].dataset.headerMenuTextColor
      );
    }
    /**
     * get direction & set custom transitions
     * with delay for content animation items
     * */
    handleSlideChangeAnimations(swiper) {
      let delay = 300;
      const queryElement = `[data-index="${swiper.activeIndex}"]`;
      const queryArray = [...(swiper.wrapperEl.querySelector(queryElement).querySelectorAll('.hero__animation') || [])];
      if (!queryArray.length) {
        return;
      }
      const allowMobileAnimation = swiper.wrapperEl.closest('.hero__content')?.dataset.animationMobile === 'true';
      if (!allowMobileAnimation && DeviceDetector.isMobile()) {
        queryArray.forEach(element => {
          element.classList.remove('in-delay');
        });
        return;
      }
      // set all element in delay
      queryArray.forEach(element => {
        element.classList.add('in-delay');
      });

      // get direction and set transitions
      if (this.lastActiveIndex > swiper.activeIndex) {
        delay = 650 + delay;
        swiper.wrapperEl.style.transitionDuration = '1000ms';
        swiper.wrapperEl.style.transitionTimingFunction = 'cubic-bezier(0.45, 0.00, 0.15, 0.95)';
      } else if (this.lastActiveIndex < swiper.activeIndex) {
        delay = 1000 + delay;
        swiper.wrapperEl.style.transitionDuration = '1000ms';
        swiper.wrapperEl.style.transitionTimingFunction = 'cubic-bezier(0.45, 0.00, 0.15, 0.95)';
      }

      // set delay calculated per item
      setTimeout(() => {
        if (this.lastActiveIndex > swiper.activeIndex) {
          delay = 325 + delay;
        } else if (this.lastActiveIndex < swiper.activeIndex) {
          delay = 500 + delay;
        }
        queryArray.forEach((element, index) => {
          if (index === 1) {
            delay = delay + 50;
          } else if (index === 2) {
            delay = delay + 175;
          } else if (index === 3) {
            delay = delay + 300;
          }
          element.classList.remove('in-delay');
        });
      }, delay);

      // set last active global
      this.lastActiveIndex = swiper.activeIndex;
    }
    addKeyboardNavigation() {
      document.addEventListener('keydown', event => {
        if (this.isInViewport()) {
          if (event.key === 'ArrowRight') {
            const nextButton = this.querySelector('.swiper-button--next');
            if (nextButton) {
              nextButton.click();
            }
          }
          if (event.key === 'ArrowLeft') {
            const prevButton = this.querySelector('.swiper-button--prev');
            if (prevButton) {
              prevButton.click();
            }
          }
        }
      });
    }

    isInViewport() {
      const rect = this.getBoundingClientRect();
      return (
        rect.top < window.innerHeight && // top part in viewport
        rect.bottom > 0 && // bottom part in viewport
        rect.left < window.innerWidth && // left part in viewport
        rect.right > 0 // right part in viewport
      );
    }
  }
  customElements.define('hero-slider', HeroSlider);
}

(() => {
  const videoSelector = '.hero-banner video[autoplay]';
  const ua = navigator.userAgent;
  const isIOS = /iPad|iPhone|iPod/.test(ua) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
  const isSafari = /Safari/.test(ua) && !/Chrome|Chromium|CriOS|FxiOS|Edg|OPR|Android/.test(ua);
  const shouldPatchSafariMedia = isIOS || isSafari || window.Shopify?.designMode;

  if (!shouldPatchSafariMedia) {
    return;
  }

  let resumeTimer = null;

  function isNearViewport(video) {
    const style = window.getComputedStyle(video);
    const rect = video.getBoundingClientRect();
    const margin = 120;

    return video.offsetParent !== null
      && style.display !== 'none'
      && style.visibility !== 'hidden'
      && rect.width > 0
      && rect.height > 0
      && rect.bottom >= -margin
      && rect.top <= window.innerHeight + margin
      && rect.right >= -margin
      && rect.left <= window.innerWidth + margin;
  }

  function canAutoplay(video) {
    return video instanceof HTMLVideoElement
      && video.isConnected
      && video.matches(videoSelector)
      && !document.hidden
      && !video.controls
      && isNearViewport(video);
  }

  function prepareVideo(video) {
    video.autoplay = true;
    video.loop = true;
    video.muted = true;
    video.defaultMuted = true;
    video.playsInline = true;
    video.setAttribute('muted', '');
    video.setAttribute('playsinline', '');
  }

  function safePlay(video) {
    const playPromise = video.play();

    if (playPromise && typeof playPromise.catch === 'function') {
      playPromise.catch(() => {});
    }
  }

  function nudgeVideo(video) {
    if (!Number.isFinite(video.duration) || video.duration <= 0.2 || video.readyState < 2) {
      return false;
    }

    try {
      const nextTime = Math.min((video.currentTime || 0) + 0.08, video.duration - 0.05);
      video.currentTime = Math.max(0, nextTime);
      return true;
    } catch (error) {
      return false;
    }
  }

  function reloadVideo(video) {
    try {
      video.load();
    } catch (error) {
      return;
    }

    if (video.readyState >= 2) {
      safePlay(video);
      return;
    }

    video.addEventListener('loadeddata', () => safePlay(video), { once: true });
  }

  function resumeVideo(video, aggressive = false) {
    if (!canAutoplay(video)) {
      return;
    }

    prepareVideo(video);
    const startTime = video.currentTime || 0;
    safePlay(video);

    if (!aggressive) {
      return;
    }

    window.setTimeout(() => {
      if (!canAutoplay(video)) {
        return;
      }

      const moved = Math.abs((video.currentTime || 0) - startTime) > 0.04;
      if (!video.paused && moved) {
        return;
      }

      nudgeVideo(video);
      safePlay(video);

      const retryTime = video.currentTime || 0;
      window.setTimeout(() => {
        if (!canAutoplay(video)) {
          return;
        }

        const movedAfterRetry = Math.abs((video.currentTime || 0) - retryTime) > 0.04;
        if (video.paused || !movedAfterRetry) {
          reloadVideo(video);
        }
      }, 600);
    }, 450);
  }

  function syncHeroVideos(root = document, aggressive = false) {
    root.querySelectorAll(videoSelector).forEach(video => resumeVideo(video, aggressive));
  }

  function pauseHeroVideos() {
    document.querySelectorAll(videoSelector).forEach(video => {
      if (video instanceof HTMLVideoElement && isNearViewport(video) && !video.controls) {
        video.pause();
      }
    });
  }

  function scheduleResume(aggressive = true) {
    window.clearTimeout(resumeTimer);
    resumeTimer = window.setTimeout(() => {
      syncHeroVideos(document, aggressive);
      requestAnimationFrame(() => syncHeroVideos(document, aggressive));
    }, 200);
  }

  window.addEventListener('pageshow', event => {
    const restoredFromHistory = event.persisted
      || performance.getEntriesByType?.('navigation')?.[0]?.type === 'back_forward';

    scheduleResume(restoredFromHistory);
  });

  window.addEventListener('pagehide', pauseHeroVideos);
  window.addEventListener('focus', () => scheduleResume(true));

  document.addEventListener('visibilitychange', () => {
    if (document.hidden) {
      pauseHeroVideos();
      return;
    }

    scheduleResume(true);
  });

  document.addEventListener('shopify:section:load', event => {
    syncHeroVideos(event.target, true);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => syncHeroVideos());
  } else {
    syncHeroVideos();
  }
})();